var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAccountSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 12C15.5 10.34 14.16 9 12.5 9C10.84 9 9.5 10.34 9.5 12C9.5 13.66 10.84 15 12.5 15C12.91 15 13.31 14.92 13.67 14.76",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.37988 20.5803L8.46988 21.2103C9.25988 21.6803 10.2799 21.4003 10.7499 20.6103L10.8599 20.4203C11.7599 18.8503 13.2399 18.8503 14.1499 20.4203L14.2599 20.6103C14.7299 21.4003 15.7499 21.6803 16.5399 21.2103L18.2699 20.2203C19.1799 19.7003 19.4899 18.5303 18.9699 17.6303C18.0599 16.0603 18.7999 14.7803 20.6099 14.7803C21.6499 14.7803 22.5099 13.9303 22.5099 12.8803V11.1203C22.5099 10.0803 21.6599 9.22031 20.6099 9.22031C19.5999 9.22031 18.9199 8.82031 18.6799 8.19031C18.4899 7.70031 18.5699 7.06031 18.9699 6.37031C19.4899 5.46031 19.1799 4.30031 18.2699 3.78031L17.4599 3.32031",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.14 3.57945C13.24 5.14945 11.76 5.14945 10.85 3.57945L10.74 3.38945C10.28 2.59945 9.26 2.31945 8.47 2.78945L6.74 3.77945C5.83 4.29945 5.52 5.46945 6.04 6.37945C6.95 7.93945 6.21 9.21945 4.4 9.21945C3.36 9.21945 2.5 10.0694 2.5 11.1194V12.8794C2.5 13.9194 3.35 14.7794 4.4 14.7794C6.21 14.7794 6.95 16.0594 6.04 17.6294",
    stroke: "#04080B",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccountSettings);
export default __webpack_public_path__ + "static/media/accountSettings.7a72bf4c78fe74be0939dfc6bc0e19bb.svg";
export { ForwardRef as ReactComponent };